// What the theme picker, wallpaper gallery and Looks grid list. A seasonal item is listed during
// its week, and afterwards only for someone still using it (shared/seasons.js). Kept apart from
// the controls so the lists can be checked without a page.
import { THEMES, THEME_GROUP_ORDER, WALLPAPER_PRESETS } from "../shared/settings-schema.js";
import { bundleMatches } from "../shared/bundles.js";
import { lookAccess } from "../shared/look-perks.js";
import { offered } from "../shared/seasons.js";

// Themes grouped for the picker, with "Match system" last.
export function themeGroups(current) {
	const byGroup = {};
	for (const [id, t] of Object.entries(THEMES)) {
		if (id === "auto" || !offered(t, id === current)) continue;
		(byGroup[t.group] || (byGroup[t.group] = [])).push([id, t.label]);
	}
	const groups = THEME_GROUP_ORDER.filter((g) => byGroup[g]).map((g) => ({ label: g, options: byGroup[g] }));
	groups.push({ label: "", options: [["auto", THEMES.auto.label]] });
	return groups;
}

// The preset wallpapers that get a tile; `current` is the wallpaper setting.
export const wallpaperPresets = (current) => WALLPAPER_PRESETS.filter((w) => offered(w, current === w.id));

// Whether a built-in look gets a tile.
export const lookListed = (b, perks) => lookAccess(b, perks) !== "hidden" && offered(b, bundleMatches(b.settings));
